import React from "react";
import AdsVideo from "../assets/Images/Ads.mp4";

const Ads = () => {
  return (
    <div className="display-container">
      <div className="video-wrapper">
        <video
          className="responsive-video"
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        >
          <source src={"https://storage.googleapis.com/pllayer-assests/panda-pickleball/Panda_Video.MP4"} type="video/mp4" />
        </video>
      </div>
    </div>
  );
};

export default Ads;
